import React from 'react';
import Navbar from '../navigation/navBar';
import Footer from '../navigation/footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useServicePopup } from '../services/ServicePopupContext';

function MainLayout({children}) {
    const { openPopup } = useServicePopup();

    const handleServiceClick = (serviceId) => {
        openPopup(parseInt(serviceId));
        return false;
    };

    return (
        <div>
            <Navbar
                home={'/'}
                s1={'1'}
                s2={'2'}
                s3={'3'}
                s4={'4'}
                s5={'5'}
                s6={'6'}
                about={'/qui-sommes-nous'}
                articles={'/articles'}
                location={'/ou-nous-rencontrer'}
                contact={'/contact'}
                facebook={'https://www.facebook.com/MesProcedures.fr/'}
                instagram={'https://www.instagram.com/mesprocedures.fr'}
                tiktok={'https://www.tiktok.com/@mesprocedures.fr'}
                phone={'+33189715961'}
                onServiceClick={handleServiceClick}
            />
            {children}
            <Footer
                home={'/'}
                s1={'1'}
                s2={'2'}
                s3={'3'}
                s4={'4'}
                s5={'5'}
                s6={'6'}
                about={'/qui-sommes-nous'}
                articles={'/articles'}
                location={'/ou-nous-rencontrer'}
                contact={'/contact'}
                privacy={'politique-de-confidentialite'}
                facebook={'https://www.facebook.com/MesProcedures.fr/'}
                instagram={'https://www.instagram.com/mesprocedures.fr'}
                tiktok={'#'}
                phone={'+33189715961'}
                onServiceClick={handleServiceClick}
            />
        </div>
    );
}

export default MainLayout;